// removed by extract-text-webpack-plugin
module.exports = {"btn-primary-bg-color":"#8c1515","light-text-color":"#bbbbbb","navigator":"MAvnh9PGhNaT6CoDjjN1_","inactive":"_1lIrYwYvw5ITgPBcQraTy_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/navigator/style.css
// module id = 746
// module chunks = 0